import "../../styles/home.css";
import Partners from "./partners";
import HomeHero from "./homeHero";
import HomeServices from "./homeServices";
import ChooseUs from "./homeChooseUs";
import HomeFaqs from "./homeFaqs";

function Home() {
  return (
    <div>
      <HomeHero />
      <HomeServices />
      <ChooseUs />
      <HomeFaqs />
      <Partners />
    </div>
  );
}

export default Home;
